<template>
  <div class="col-12">
    <div v-show="uploadDocumentsElement">
      <div class=" row text-center m-5">
        <h2 class="ui inverted purple text"> <strong> Upload Documents</strong></h2>
        <p class="text-muted fw-light m-3">Please provide the documents <br />indicated below:</p>
        <p>Copy of valid National ID or Passport, Proof of residence, Passport sized photo.</p>
        <small>To avoid delays, make sure your documents are clear.</small>
      </div>

      <div class="row d-flex justify-content-center align-items-center mt-5">
        <div class="col-11 col-lg-9">
          <div class="ui violet floating message mr-4 ml-4">
            <div class="header">
              <div class="row">
                <div class="col-1">
                  <input type="checkbox" id="checkbox" v-model="submitDocumentsLater">
                </div>
                <div class="col-11">
                  <p v-if="!submitDocumentsLater">Check the box to submit documents later.</p>
                  <p v-if="submitDocumentsLater">Uncheck the box to submit documents now.</p>
                </div>
              </div>
            </div>
          </div>
          <button v-if="submitDocumentsLater" class="ui button purple fluid mt-4"
            @click="submitDocsLater()">Proceed</button>
          <button v-if="submitDocumentsLater" class="ui button  grey fluid mt-4 mb-4" @click="back()">Back</button>
        </div>
      </div>

      <div v-if="!submitDocumentsLater" class="row d-flex justify-content-center align-items-center mt-5">
        <div class="col-11 col-lg-9">
          <form v-bind:class="{ 'ui form loading': isBusy() }" @submit.prevent="changePage()">
            <div class="row">
              <div class="col d-flex align-items-center">
                <a-select @change="startImageUpload" placeholder="Choose a document type" allowClear>
                  <a-select-option v-for="fileType of model.fileTypes" :key="fileType.label" :value="fileType.label">
                    {{ fileType.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>

            <br />

            <a-upload-dragger v-if="showFileUploader" name="file" :before-upload="beforeUpload"
              @change="storeImageUpload">
              <p class="ant-upload-drag-icon">
                <InboxOutlined style="color:purple" />
              </p>
              <p class="ant-upload-text">
                Click or drag file to this area to upload
              </p>
              <p class="ant-upload-hint">
                You can upload multiple files at once
              </p>
            </a-upload-dragger>

            <div v-if="model.files.length > 0">
              <div class="row mt-5">
                <p class="col-3 h6">Doc Type</p>
                <p class="col-4 h6">File name</p>
                <p class="col-2 h6">Size</p>
                <p class="col-1 h6">Preview</p>
                <p class="col-1 h6"></p>
              </div>
              <div v-for="file of model.files" :key="file.docType" class="row border-top mt-1 pt-1">
                <div class="col-3">{{ file.docType }}</div>
                <div class="col-4">{{ file.file.name }}</div>
                <div class="col-2 ">{{ (file.file.size / 1028).toFixed(2) }} KB</div>
                <div class="col-2 " style="cursor:pointer;" @click="showModalD(file.file)">
                  <i class="eye icon"></i>
                </div>
                <div class="col-1" style="cursor:pointer;" @click="removeItem(file)">
                  <i class="trash icon"></i>
                </div>
              </div>
            </div>
            <div v-if="showModal">
              <div class="modal-overlay">
                <div class="modal-content">
                  <template v-if="isPdf(fileType)">
                    <object :data="filePreviewUrl" type="application/pdf" width="100%" height="500px">
                      <p>PDF Preview not available</p>
                    </object>
                  </template>
                  <template v-else-if="isImage(fileType)">
                    <img :src="filePreviewUrl" alt="Image Preview" />
                  </template>
                  <button @click="hideModal">Close Preview</button>
                </div>
              </div>
            </div>

            <div v-if="!areFilesUploadedValid" class="text-danger mt-4">
              {{ missingFile }}
            </div>

            <div class="ui purple floating message m-4">
              <div class="mb-2">
                <div class="header">
                  <input type="checkbox" id="checkbox" v-model="isChecked">
                  `&nbsp; To Proceed, Tick This Box Only If:
                </div>
                <ul class="list">
                  <li>The address provided on the personal information corresponds to the address on the proof of
                    residence or the affidavit from
                    the property owner.</li>
                  <li>The proof of residence is dated within the last 3 months.</li>
                </ul>
              </div>
            </div>

            <button class="ui button purple fluid mt-4" :disabled="!isFormValid" type="submit">Submit Documents And
              Proceed</button>
            <button class="ui button grey fluid mt-4 mb-4" @click="back()">Back</button>
          </form>
        </div>
      </div>
    </div>
    <div v-show="makePaymentElement">
      <div class=" row text-center m-5">
        <h3 v-if="success" class="ui inverted purple text"> <strong> {{ title }}</strong>
        </h3>
        <h3 v-if="!success" class="ui inverted purple text"><strong> {{ title
        }}</strong>
        </h3>

      </div>
      <div class="row d-flex justify-content-center align-items-center mt-5">
        <div class="col-11 col-lg-9">
          <div class="ui violet floating message m-4">
            <div class="header mb-2">
              <div v-if="loadingRequest" class="ui active inline loader"></div>
              {{ subTitle }}
            </div>
            <p> {{ message }}</p>
          </div>
          <button v-if="retryButton && !submitDocumentsLater" class="ui button  purple fluid mt-4 mb-4" @click="uploadFiles()">Retry
            Payment</button>
            <button v-if="retryButton && submitDocumentsLater" class="ui button  purple fluid mt-4 mb-4" @click="submitDocsLater()">Retry @
            Payment</button>
          <button v-if="logoutButton" class="ui button  grey fluid mt-4 mb-4" @click="login()">Logout</button>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baseMethods from "@/utils/baseMethods";
import { URLS } from "@/utils/constants";
import { http } from "@/utils/http";
import { Notify } from "@/utils/notifications";
import { utils } from "@/utils/utils";
import { InboxOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';

export default {
  name: "T24UploadDocuments",
  components: {
    InboxOutlined,
  },
  data() {
    return {
      subTitle: '',
      title: '',
      message: '',
      missingFile: '',
      success: true,
      retryButton: false,
      loadingRequest: false,
      isChecked: false,
      submitDocumentsLater: false,
      logoutButton: false,
      uploadDocumentsElement: false,
      makePaymentElement: false,
      customer: {
        mobileNumber: localStorage.getItem("phone-number"),
        email: localStorage.getItem("email"),
        title: localStorage.getItem("title"),
        firstName: localStorage.getItem("first-name"),
        lastName: localStorage.getItem("last-name"),
        idNumber: localStorage.getItem("identity-doc-no"),
        gender: localStorage.getItem("gender"),
        street: localStorage.getItem("street"),
        town: localStorage.getItem("town"),
        currency: localStorage.getItem("currency-type"),
        dateOfBirth: localStorage.getItem("dateOfBirth"),
        lineOfBusiness: localStorage.getItem("lineOfBusiness"),
        sourceOfIncome: localStorage.getItem("sourceOfIncome"),
        monthlyIncomeAmount: localStorage.getItem("monthlyIncomeAmount"),
        activityExpectedOnAccount: localStorage.getItem("activityExpectedOnAccount"),
        signature: localStorage.getItem("signature"),
        customerUid: localStorage.getItem("uid"),
        accountType: localStorage.getItem('account-type'),
        status: 'PENDING',
        //  gotCustomerData: false,
        requestType: "PRE_PROCESS_CURRENT_ACCOUNT",
      },
      model: {
        // list of objs
        files: [],
        fileTypes: [],
        docTypes: [],
      },
      tmpFileType: "",
      showFileUploader: false,
      errors: {},
      operations: 0,
      columns: [
        {
          title: "Type",
          dataIndex: "dataType",
          key: "dataType",
        },
      ],
      filePreviewUrl: null,
      fileType: null,
      showModal: false,
    };
  },
  methods: {

    login() {
      this.$router.push("/account-opening/login");
    }
    ,
    validateFileUpload() {
      //  const uploadedFileTypes = [];

      if (!this.model.fileTypes || this.model.fileTypes.length === 0) {
        console.error('No file types defined in model');
        return false;
      }

      for (const fileType of this.model.fileTypes) {
        if (!this.model.docTypes.includes(fileType.label)) {
          console.error(`Please upload a ${fileType.name} file.`);
          this.missingFile = `Please upload your ${fileType.name}.`;
          return false;
        }
      }

      return true;
    }
    ,
    setDefaults() {

      this.message = 'In approximately 10 seconds you will be asked to enter your EcoCash PIN  on your mobile phone to facilitate the account opening fee. This will enable us to co that we can accept your account opening request.';
      this.title = 'Almost Done!';
      this.subTitle = 'Pending Ecocash Payment Authorization';
      this.success = true;
      this.retryButton = false;
      this.logoutButton = false;
      this.loadingRequest = true;
    },

    showUploadDocuments() {
      this.uploadDocumentsElement = true;
    },
    removeItem(item) {
      let index = this.model.files.indexOf(item);
      let indexDocType = this.model.docTypes.indexOf(item.docType);
      if (index > -1) {
        this.model.files.splice(index, 1);
      }
      if (indexDocType > -1) {
        this.model.docTypes.splice(indexDocType, 1);
      }
      this.showFileUploader = true;
    },
    startImageUpload(item) {
      this.tmpFileType = item;
      this.showFileUploader = true;

    },
    cancel() {
      this.model.files = null;
    },
    storeImageUpload(info) {
      this.model.files.push(info.file);
      this.model.docTypes.push(this.tmpFileType);
      this.model.files.splice(-1);
      console.table(this.model.files);
      console.table(this.model.docTypes);

      console.log(info.file);

      this.showFileUploader = false;
    },
    back() {
      this.$router.push("/account-opening/signature");
    },

    changePage() {
      this.uploadDocumentsElement = false;
      this.makePaymentElement = true;

      this.uploadFiles();
    },

    submitDocsLater() {
      this.uploadDocumentsElement = false;
      this.makePaymentElement = true;
      this.setDefaults();

      this.postNoAuthAndNoBaseUrl(
        URLS.processAccount,
        this.customer,
        "Customer Data Uploaded",
        null,
        true
      ).then((res) => {
        if (!res) return;
        if (res.errors) return (this.errors = res.errors);
        if (res.body.status === "COMPLETE") {

          if (this.model.files.length === 0) {
            Notify.fire("Oops", "You forgot to upload a file", "error");
            return;
          }

        } else {
          if (res.body.requestType === "ECOCASH_DEPOSIT") {
            this.title = 'Sorry, Payment Authorization Failed'
            this.success = false;
            this.message = 'Click the button below to retry the payment process.';
            this.retryButton = true;
            this.logoutButton = true;
            this.loadingRequest = false;

          }
          this.title = 'Very Sorry, An Error Has Occurred'
          this.success = false;
          this.message = 'Click the button below to retry the payment process. If the error persists, please contact us on 0808 8888 or customerservice@stewardbank.co.zw for assistance.';
          this.retryButton = true;
          this.logoutButton = true;
          this.loadingRequest = false;

        }
      });
    },

    uploadFiles() {

      this.setDefaults();

      this.postNoAuthAndNoBaseUrl(
        URLS.processAccount,
        this.customer,
        "Customer Data Uploaded",
        null,
        true
      ).then((res) => {
        // if (!res) return;
        // if (res.errors) return (this.errors = res.errors);
        if (res.body.status === "COMPLETE") {

          if (this.model.files.length === 0) {
            Notify.fire("Oops", "You forgot to upload a file", "error");
            return;
          }

          // for file uploaded we do an iteration
          //   let count = 0;
          console.log(this.model);
          console.log("we are here")

          localStorage.setItem('model', JSON.stringify(this.model));

          this.model.files.forEach((file) => {
            let formData = new FormData();
            formData.append("phone", localStorage.getItem("phone-number"));
            formData.append("customerUid", localStorage.getItem("uid"));
            formData.append("documentTypeLabel", file.docType);
            formData.append("citizenId", localStorage.getItem("identity-doc-no"));

            formData.append("files", file.file);

            this.addOp();

            console.log("uploading docs");

            http
              .postFormDataNoAuth(URLS.documents + "/upload", formData)
              .then((res) => {

                this.title = 'Complete';
                this.message = 'Your application has been submitted successfully. Once authorized, your account number will be sent to you via SMS. Thank you for choosing TN CyberTech Bank!';
                this.subTitle = 'TN CyberTech Bank';
                this.success = true;
                this.logoutButton = true;
                this.loadingRequest = false;
                localStorage.clear()
                // count++;
                utils.logger("upload result", res);
                this.removeOp();
                return this.handleGetResponse(res, true);
              })
              .then((res) => {
                if (!res) return;
                if (res.errors) return (this.errors = res.errors);

              });

          });

        } else {
          if (res.body.requestType === "ECOCASH_DEPOSIT") {
            this.title = 'Sorry, Payment Authorization Failed'
            this.success = false;
            this.message = 'Click the button below to retry the payment process.';
            this.retryButton = true;
            this.logoutButton = true;
            this.loadingRequest = false;


          }
          this.title = 'Very Sorry, An Error Has Occurred'
          this.success = false;
          this.message = 'Click the button below to retry the payment process. If the error persists, please contact us on 0808 8888 or customerservice@stewardbank.co.zw for assistance.';
          this.retryButton = true;
          this.logoutButton = true;
          this.loadingRequest = false;

        }
      });
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        message.error("Document must be smaller than 2MB!");
        return false;
      }

      let newFile = {};
      newFile.file = file;
      newFile.docType = this.tmpFileType;

      this.model.files.push(newFile);
      return false;
    },

    getCustomerById() {
      http
        .getIdentity(
          URLS.customerByPhone + localStorage.getItem("phone-number")
        ).then((res) => {
          console.log(res);
          localStorage.setItem("uid", res.body.uid);
          this.customer.customerUid = res.body.uid;
        });
    },
    getTypes() {
      this.getNoAuth(URLS.documents + "/types")
        .then((response) => (this.model.fileTypes = response.body));

      console.log(this.model.fileTypes);
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      this.fileType = file.type;
      this.filePreviewUrl = URL.createObjectURL(file);
    },
    isPdf(fileType) {
      return fileType === 'application/pdf';
    },
    isImage(fileType) {
      return fileType.startsWith('image/');
    },
    showModalD(file) {
      this.fileType = file.type;
      this.filePreviewUrl = URL.createObjectURL(file);
      this.showModal = true;
    },
    hideModal() {
      this.showModal = false;
    },

    ...baseMethods,
  },
  mounted() {
    this.showUploadDocuments();
    this.getTypes();
    this.getCustomerById();
  },
  computed: {

    isFormValid() {
      return (
        this.validateFileUpload() && this.isChecked
        // this.model.files.length > 0
      );
    },
    areFilesUploadedValid() {
      return (
        this.validateFileUpload()
      )
    }
  }
};
</script>

<style scoped></style>
